import {
  base_colorAction,
  base_colorContentBorder,
  base_colorSurface,
  base_colorSurfaceMuted,
  notification_colorAlert,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_size_md,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const root = css`
  position: relative;
  display: inline-flex;
`

/** Anchors the menu below the trigger, right-aligned, above the sticky Subnav. */
export const menuAnchor = css`
  position: absolute;
  top: calc(100% + ${spacing(2)});
  right: 0;
  z-index: 80;
`

/**
 * Feature-local menu surface. The ext-ui Dropdown/MenuOptionTertiary are only
 * fully styled on the `latest` design-system channel; the app renders `live`,
 * where their background and title/subtext layout are missing — so the menu is
 * built here instead, matching the design.
 */
export const menu = css`
  min-width: 300px;
  background-color: ${base_colorSurface};
  border: 1px solid ${base_colorContentBorder};
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(20, 20, 43, 0.1);
  padding: ${spacing(1)} 0;
  display: flex;
  flex-direction: column;
`

export const menuItem = css`
  display: flex;
  align-items: flex-start;
  gap: ${spacing(3)};
  width: 100%;
  padding: ${spacing(2.5)} ${spacing(4)};
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  /* Icon + title inherit this; severe overrides it. */
  color: ${base_colorAction};

  @media (prefers-reduced-motion: no-preference) {
    transition: background-color 120ms ease-out;
  }

  &:hover,
  &:focus-visible {
    background-color: ${base_colorSurfaceMuted};
  }

  &:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: -2px;
  }

  &[data-disabled='true'] {
    cursor: default;
    opacity: 0.5;

    &:hover {
      background-color: transparent;
    }
  }
`

export const menuItemSevere = css`
  ${menuItem};
  color: ${notification_colorAlert};

  &:focus-visible {
    outline-color: ${notification_colorAlert};
  }
`

export const itemIcon = css`
  flex-shrink: 0;
  display: inline-flex;
  margin-top: 1px;
`

export const itemText = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(0.5)};
`

export const itemTitle = css`
  color: inherit;
  font-family: ${font_family_weight_medium};
  font-size: ${font_size_md};
`

export const itemSubtext = css`
  color: ${text_colorTextSecondary};
  font-size: ${font_size_sm};
`

export const separator = css`
  height: 1px;
  width: 100%;
  background-color: ${base_colorContentBorder};
  margin: ${spacing(1)} 0;
`
